import initializeComponent from 'Shared/react-initialize';
import { SharedNavBar, NavData } from 'Guide/PageNavigation/SharedNavBar';

export function TeamNav(props: NavData) {
   const { breadCrumbs, navTabs } = props;

   return <SharedNavBar breadCrumbs={breadCrumbs} navTabs={navTabs} />;
}

initializeComponent('TeamNavComponent', TeamNav);
